import useSWR from 'swr';

import { getSubscribers } from '../api';
import type { ISubscibersBody } from '../subscribers/types';

export function useSubscribers(propertyId: string) {
  // Tell SWR that the response is the body with a `subscribers` array
  const { data, error, isValidating } = useSWR<ISubscibersBody>(
    () => (propertyId ? ['subscribers', propertyId] : null),
    () => getSubscribers(propertyId),
  );

  return {
    // Extract the actual array (or default to empty)
    subscribers: data?.subscribers ?? [],
    isLoading: isValidating,
    isError: !!error,
  };
}
